// Purpose: Preserve sponsor-scoped credential capture/access through the shared boundary.
// Dependencies: business_verification_invite; no browser storage.
// Behavior: Sponsor credentials never authorize vendors or another event/record.
import { captureBusinessVerificationInvite, getBusinessVerificationInvite } from "./business_verification_invite";

export const captureSponsorVerificationInvite = () => captureBusinessVerificationInvite("sponsor");
export const getSponsorVerificationInvite = (eventslug, sponsorId) => getBusinessVerificationInvite("sponsor", eventslug, sponsorId);
